import BodyText from "@ancon/wildcat-ui/web/orderweb/BodyText";
import clsx from "clsx";
import MoonIcon from "@ancon/wildcat-ui/shared/icons/moon-fill.svg";

import styles from "./OutletCardOutletStatus.module.scss";

interface OutletCardOutletStatusProps {
  containerClassName?: string;
  isOutletOpen?: boolean;
}

export default function OutletCardOutletStatus({
  containerClassName,
  isOutletOpen,
}: OutletCardOutletStatusProps) {
  const isWhiteLabeled = true;

  const availabilityLabels = ["Opens Today at 13:30", "Tomorrow at 13:30"];
  const availabilityLabel =
    availabilityLabels[Math.floor(Math.random() * availabilityLabels.length)];

  const isAcceptingOfflineOrders = false;

  return (
    <div
      className={clsx(
        styles.outletStatusWrapper,
        {
          [styles.wl]: isWhiteLabeled,
          [styles.hasContent]: !isOutletOpen || availabilityLabel,
        },
        containerClassName
      )}
    >
      {!isOutletOpen &&
        (isWhiteLabeled ? (
          <>
            <MoonIcon />
            <BodyText>
              {isAcceptingOfflineOrders ? "Accepting Pre-Orders" : "Closed"} •{" "}
              {availabilityLabel ?? ""}
            </BodyText>
          </>
        ) : (
          <>
            <BodyText className={styles.outletStatusText}>
              {isAcceptingOfflineOrders ? "Accepting Pre-Orders" : "Closed"}
            </BodyText>
            {availabilityLabel && (
              <div className={styles.outletAvailabilityTag}>
                <BodyText>{availabilityLabel}</BodyText>
              </div>
            )}
          </>
        ))}
    </div>
  );
}
